import { State } from '../../types';

export const idaho: State = {
  name: 'Idaho',
  abbreviation: 'ID',
  terms: [
    {
      word: 'Acequia',
      phonetic: 'uh-SEEK-we-uh',
      // audioUrl: '/audio/acequia.mp3',
      description: 'This small town\'s name is derived from the Spanish word for irrigation ditch.'
    },
    {
      word: 'Boise',
      phonetic: 'BOY-see',
      audioUrl: '/audio/boise.mp3',
      description: 'Capital city of Idaho'
    },
    {
      word: 'Cocolalla',
      phonetic: 'koh-koh-LAH-lah',
      // audioUrl: '/audio/cocolalla.mp3',
      description: 'A community in Bonner County, pronounced "koh-koh-LAH-lah," not "koh-koh-LAY-lah."'
    },
    {
      word: 'Coeur d\'Alene',
      phonetic: 'KOR-duh-lane',
      audioUrl: '/audio/coeurdalene.mp3',
      description: 'City in northern Idaho'
    },
    {
      word: 'Kamiah',
      phonetic: 'KAM-ee-eye',
      // audioUrl: '/audio/kamiah.mp3',
      description: 'A city in Lewis County, pronounced "KAM-ee-eye," not "KAM-ee-ah."'
    },
    {
      word: 'Kootenai',
      phonetic: 'KOOT-nee',
      // audioUrl: '/audio/kootenai.mp3',
      description: 'A county in northern Idaho, its name is often mispronounced due to the silent "ai" at the end.'
    },
    {
      word: 'Kooskia',
      phonetic: 'KOO-skee',
      // audioUrl: '/audio/kooskia.mp3',
      description: 'This town\'s name is pronounced with two syllables, ignoring the "a" at the end.'
    },
    {
      word: 'Kuna',
      phonetic: 'KYOO-nuh',
      // audioUrl: '/audio/kuna.mp3',
      description: 'A city in Ada County, pronounced "KYOO-nuh," not "KOO-nah."'
    },
    {
      word: 'Lapwai',
      phonetic: 'LAP-way',
      // audioUrl: '/audio/lapwai.mp3',
      description: 'A city in Nez Perce County, pronounced "LAP-way," not "LAP-wah."'
    },
    {
      word: 'Mackay',
      phonetic: 'MACK-ee',
      // audioUrl: '/audio/mackay.mp3',
      description: 'A city in Custer County, pronounced "MACK-ee," not "MACK-ay."'
    },
    {
      word: 'Moscow',
      phonetic: 'MOSS-koe',
      // audioUrl: '/audio/moscow.mp3',
      description: 'Unlike the Russian capital, this Idaho city is pronounced with a long "o" sound at the end.'
    },
    {
      word: 'Owyhee',
      phonetic: 'oh-WYE-hee',
      // audioUrl: '/audio/owyhee.mp3',
      description: 'A county and river, pronounced "oh-WYE-hee," not "oh-WEE-hee."'
    },
    {
      word: 'Pend Oreille',
      phonetic: 'POND-uh-RAY',
      // audioUrl: '/audio/pend_oreille.mp3',
      description: 'A lake and county, pronounced "POND-uh-RAY," not "PEND-or-EEL."'
    },
    {
      word: 'Weippe',
      phonetic: 'WEE-ipe',
      // audioUrl: '/audio/weippe.mp3',
      description: 'A small town in Clearwater County, pronounced with a long "i" sound.'
    },
    {
      word: 'Weiser',
      phonetic: 'WEE-zer',
      // audioUrl: '/audio/weiser.mp3',
      description: 'A city in Washington County, pronounced "WEE-zer," not "WYE-zer."'
    }
  ]
};